/**
 * Decide whether the current time falls inside the configured display window.
 *
 * The dates are rendered into the markup as ISO 8601 (UTC) instead of being checked
 * in PHP, because pages are served from the Cloudflare edge cache: a page rendered
 * while the message was active would otherwise keep showing it after the end date.
 *
 * @param {HTMLElement} button
 * @returns {boolean}
 */
function isWithinDisplayWindow(button) {
  const now = Date.now();
  const start = Date.parse(button.dataset.startDate);
  const end = Date.parse(button.dataset.endDate);

  if (!Number.isNaN(start) && now < start) {
    return false;
  }

  return Number.isNaN(end) || now < end;
}

export default function () {
  const dialog = document?.querySelector('.crisis-message__dialog');
  const showButton = document?.querySelector('.crisis-message__open');
  const closeButton = document?.querySelector('.crisis-message__close');

  if (!showButton || !dialog || !isWithinDisplayWindow(showButton)) {
    dialog?.remove();
    showButton?.remove();
    return;
  }

  showButton.hidden = false;

  showButton.addEventListener('click', () => {
    dialog.showModal();
  });

  closeButton?.addEventListener('click', () => {
    dialog.close();
  });
}
